import { useAuthenticator } from '@aws-amplify/ui-react';
import { TextField } from "@mui/material";
import "../styles/SectionSubSectionEditor.css"
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useParams } from "react-router-dom";
import BlackButton from "./BlackButton";
import { useState } from "react";
import axios from "axios";
import Loader from "./Loader";
import { proxy } from "../proxy";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
function SectionEditor(){
    const { user} = useAuthenticator((context) => [context.user]);
    const { section,sectionid } = useParams();
    const [currentSection,setCurrentSection]=useState()
    const [isLoading,setIsLoading]=useState(false)
    const history = useHistory()
    async function  senddata(){
        axios.put(`${proxy}/api/section`,{"_id":`${sectionid}`,"section":`${currentSection}`}, {
            withCredentials: true,
            headers: {
              Accept: "application/json",
              'Authorization':user.signInUserSession.idToken.jwtToken,

              "Content-Type": "application/json",
              "Access-Control-Allow-Credentials": true,
            },
          }).then((res) => {
                setIsLoading(false);
            //   console.log(res.data);
              alert("Section Edited")
              history.push('/sections')
          }).catch((error)=>{
            setIsLoading(false);
            alert("error")
            console.log(error);
          });
          setIsLoading(true);
    };
    return(
        <div>
            {!isLoading && <div>
                <div className="sections-header">
                    <div className="sections-title-header">
                        <p>Add Your Data here <ArrowDownwardIcon/> </p>
                    </div>
                </div>
                <div className="section-editor-components">
                    <div className="section-editor-component">
                        <div className="section-editor-component-title">
                            <p>Current Section</p>
                        </div>
                        <TextField fullWidth disabled value={section}/>
                    </div>
                    <div className="section-editor-component">
                        <div className="section-editor-component-title">
                            <p>Edit Your Section</p>
                        </div>
                        <TextField fullWidth onChange={(e)=>setCurrentSection(e.target.value)}/>
                    </div>
                    <BlackButton id="section-submit" variant="contained" style={{marginTop:"10px"}} onClick={()=>{
                            document.getElementById('section-submit').disabled=true;
                            senddata()
                            document.getElementById('section-submit').disabled=false;
                    }}> Submit</BlackButton>
                </div>
            </div>}

            {isLoading && <Loader/>}
        
        </div>

    )
}
export default SectionEditor;